// FOR COLLECTION GALLERY
$( document ).ready(function() {
  /*$('.pro-collection-gallery').slick({
    dots: true,
    infinite: true,
    speed: 200,
    cssEase: 'linear',
    arrows : false,
  });*/
  
  setInterval(function(){
    $('.pro-collection-gallery').each(function(){
      
      if($(this).hasClass('slick-initialized')){
        $(this).find('.pro-collection-gallery-item-load-time').show();
      }else{
        $(this).slick({
          dots: true,
          infinite: true,
          speed: 200,
          cssEase: 'linear',
          arrows : false,
        });
      }
      
    });
  },1000);

  


  
  // TAB COLLECTION SLIDER
  const indicator = document.querySelector(".nav-indicator");
  const items = document.querySelectorAll(".nav-item");
  
  function handleIndicator(el) {
    items.forEach((item) => {
      item.classList.remove("is-active");
      item.removeAttribute("style");
    });
  
    indicator.style.width = `${el.offsetWidth}px`;
    indicator.style.left = `${el.offsetLeft}px`;
    indicator.style.backgroundColor = el.getAttribute("active-color");
  
    el.classList.add("is-active");
    el.style.color = el.getAttribute("active-color");
  }
  
  items.forEach((item, index) => {
    item.addEventListener("click", (e) => {
      handleIndicator(e.target);
    });
    item.classList.contains("is-active") && handleIndicator(item);
  });

  $('.collection_slider').slick({
        dots: false,
    initialSlide:1,
        //infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                  infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px'
                }
            }
        ]
    });

  

  
  
  $('.nav-item').click(function(e){
    e.preventDefault();
    var df=$(this).attr('data-for');
    $('.collection_slider').slick('slickUnfilter');
    let ss = $('.collection_slider').slick('slickFilter','.'+df);
  });

  
  // VIEW BUTTON JS
  $('.nav-item-view-all').click(function(e){
      e.preventDefault();
      var df = $(this).attr('data-for');
    
      $('.view-all-box-slider').hide();
      $('.view-all-box-slider.'+df).show();
  });
  // END VIEW BUTTON JS

  
  // END TAB COLLECTION SLIDER

  
  // TAB COLLECTION GRID
  const indicatorPro = document.querySelector(".nav-indicator-pro");
  const itemsPro = document.querySelectorAll(".nav-item-pro");
  
  function handleIndicatorPro(el) {
    
    itemsPro.forEach((item) => {
      item.classList.remove("is-active");
      item.removeAttribute("style");
    });


    
  
    indicatorPro.style.width = `${el.offsetWidth}px`;
    indicatorPro.style.left = `${el.offsetLeft}px`;
    indicatorPro.style.backgroundColor = el.getAttribute("active-color");
  
    el.classList.add("is-active");
     //$('.nav-item-pro').has('font').addClass('is-active');    
    el.style.color = el.getAttribute("active-color");
  }
  
  itemsPro.forEach((item, index) => {
    item.addEventListener("click", (e) => {
      handleIndicatorPro(e.target);
      console.log(e.target.innerHTML)
    });
    item.classList.contains("is-active") && handleIndicatorPro(item);
  });

  $('.nav-item-pro').click(function(e){
    e.preventDefault();
    var df=$(this).attr('data-for');
    $('.tab-collection-grid').hide();
    $('.tab-collection-grid.'+df).show();
    
    
  });
  // END TAB COLLECTION GRID



  


  // Ip Modal Start
  var apexIpModal = document.getElementById("apex-ip-modal");
  var openApexIpModal = document.getElementById("open-apex-ip-modal");
  var apexIpModalClose = document.getElementsByClassName("apex-ip-modal-close")[0];
  
  // openApexIpModal.onclick = function() {
  //   apexIpModal.style.display = "block";
  // }
  
  // window.onload = function () {
  //     apexIpModal.style.display = "block";
  // }
   
  apexIpModalClose.onclick = function() {
    apexIpModal.style.display = "none";
  }
  
  window.onclick = function(event) {
    if (event.target == apexIpModal) {
      console.log(event.target);
      apexIpModal.style.display = "none";
    }
  }

window.addEventListener("load", function() {
	var mq = window.matchMedia("(min-width: 769px)");
    var slick_prev = document.querySelector(".collection_slider .slick-prev");
	if (mq.matches) {
      if(slick_prev){
          slick_prev.click();
        }
			}
		});

  
});


